import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { ServiceAccount } from '@/models/serviceAccount';

export const fetchServiceAccount = async (id: string): Promise<ServiceAccount> => {
  const response = await queryExecute({
    query: graphql(`
      query ServiceAccount($id: String!) {
        serviceAccount(id: $id) {
          id
          user
          service
          email
          password
          phoneNumber
          isActive
          isClosed
          isAutomatedAccount
          isManualAccount
          createdAt
          updatedAt
          operator {
            id
            firstName
            lastName
          }
        }
      }
    `),
    variables: {
      id,
    },
    fetchPolicy: 'no-cache',
  });

  return response.data.serviceAccount!;
};
